import { notifyError } from '../layouts/Notify/actions';
import {
  PHONE_NUMBER_SYNC_FAILED_KEY,
  syncPropertyDirectPhoneNumber,
} from '../services/propertyPhoneNumber.service';

// Autosave can complete several Zeus saves for the same property in quick succession; chaining the
// property-management writes per property keeps them landing in the same order as those saves.
const pendingSyncByProperty = new Map<string, Promise<unknown>>();

/**
 * Dual-writes the phone number Zeus saved for a store to the store's property in
 * property-management. A failure warns the user but never fails the store save.
 */
export const syncStorePhoneNumberToPropertyManagement =
  (savedStore: { PropertyId?: string; PhoneNumber?: string | null }): ThunkAction =>
  async (dispatch, getState) => {
    const orgId = getState().rms?.currentOrg?.orgId;
    const queueKey = savedStore.PropertyId ?? '';
    const previous = pendingSyncByProperty.get(queueKey) ?? Promise.resolve();

    const current = previous.then(async () => {
      const result = await syncPropertyDirectPhoneNumber({
        orgId,
        propertyId: savedStore.PropertyId,
        phoneNumber: savedStore.PhoneNumber,
        source: 'store',
      });

      if (result === 'failed') {
        dispatch(notifyError({ message: PHONE_NUMBER_SYNC_FAILED_KEY, translate: true }));
      }
    });

    pendingSyncByProperty.set(queueKey, current);
    await current;
    if (pendingSyncByProperty.get(queueKey) === current) {
      pendingSyncByProperty.delete(queueKey);
    }
  };
